<template>
    <PageContent>
        <PageTitle>Customer Locations<Help /></PageTitle>
        <NotReady v-if="!ready" />
        <div v-else>
            <div class="pb-3 d-flex align-items-center">
                <div class="d-inline-block me-2"><b>Show Inactive: </b></div>
                <div class="form-check form-switch">
                    <input autocomplete="off" autosuggest="off" class="form-check-input" name="txtinactive" type="checkbox" id="txtinactive" v-model="txtinactive" false-value="" true-value="checked">
                </div>
            </div>
            <div class="text-end mb-3">
                <a :href="`/locations/create`" class="btn btn-primary" v-if="$store.state.localStorage.user['Location Maint']||$root.isKfEmployee()">New Location</a>
            </div>

            <DataTable :options="tableOptions" :columns="[
                { data: 'Route No_' },
                { data: 'Location No_' },
                { data: 'Ship-to Code' },
                { data: 'Name' },
                { data: null, orderable: false, searchable: false }
              ]" ref="dataTable" class="display table table-sm table-striped table-bordered" style="width:100%">

              <thead>
                <tr>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Route</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Location</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Ship to</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Name</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);"></th>
                </tr>
                <tr>
                  <td><label class="filter-label">Route</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchColumn(0, $event)" /></td>
                  <td><label class="filter-label">Location</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchColumn(1, $event)" /></td>
                  <td><label class="filter-label">Ship to</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchColumn(2, $event)" /></td>
                  <td><label class="filter-label">Name</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchColumn(3, $event)" /></td>
                  <td></td>
                </tr>
              </thead>

              <template #column-4="{ rowData }">
                <a v-if="$store.state.localStorage.user['Location Maint']" :href="`/locations/${rowData['id']}/edit?lclocationno=${rowData['Location No_']}&lcrouteno=${rowData['Route No_']}`" class="me-1 btn btn-primary btn-sm">Edit</a>
                <a :href="`/locations/${rowData['Location No_']}/orders?route=${rowData['Route No_']}&name=${btoa(rowData['Name'])}`" class="me-1 btn btn-primary btn-sm">Order</a>
              </template>
            </DataTable>
        </div>
    </PageContent>
  </template>
  
  <script>
    import PageContent from '@/components/PageContent.vue';
    import NotReady from '@/components/NotReady.vue';
    import PageTitle from '@/components/PageTitle.vue';
    import Help from '@/components/Help.vue';
    import DataTable from 'datatables.net-vue3'
    import DataTablesCore from 'datatables.net-bs5'

    DataTable.use(DataTablesCore)

    export default {
        name: 'Locations',
        components: {PageContent, PageTitle, NotReady, Help, DataTable},

        watch:{
            txtinactive(){
                this.$refs.dataTable.dt.draw();
            },
        },
        data(){
            return {
                _:_,
                ready: false,
                txtinactive: '',
                tableOptions: null,
            }
        },
        created(){
            this.tableOptions = {
                pageLength: this.$store.state.localStorage.user['Locations_Per_Page'] ?? 25,
                lengthMenu: [[25, 50, 100, -1], [25, 50, 100, 'All']],
                layout: {
                    topStart: 'pageLength',
                    topEnd: 'search',
                    top2End: 'paging',
                    bottomStart: 'info',
                    bottomEnd: 'paging',
                },
                scrollY: '60vh',
                scrollCollapse: true,
                orderCellsTop: true,
                processing: true,
                serverSide: true,
                order: [[0, 'asc']],
                columnDefs: [{ targets: '_all', orderSequence: ['asc', 'desc'] }],
                createdRow: (row, data) => {
                    if (data.Status == 1) {
                        row.classList.add('opacity-50', 'text-muted');
                    }
                },
                ajax: {
                    url: `${this.$store.state.api}/custlocations?token=${localStorage.token}`,
                    type: 'GET',
                    data: (data) => {
                        console.log
                        return {
                            draw: data.draw,
                            start: data.start,
                            length: data.length,
                            search: data.search.value,
                            orderBy: data.columns[data.order[0].column].data,
                            orderDir: data.order[0].dir,
                            'Route No_': data.columns[0].search.value,
                            'Location No_': data.columns[1].search.value,
                            'Ship-to Code': localStorage.shipTo,
                            'Ship-to Code Search': data.columns[2].search.value,
                            'name': data.columns[3].search.value,
                            lccustno: this.$root.getCustomerNumber(),
                            show_inactive: this.txtinactive,
                        };
                    },
                },
            };
        },
        async mounted(){
            this.ready = true;
            await this.$nextTick();
            this.$refs.dataTable.dt.on('length.dt', (e, settings, len) => {
                this.$store.state.localStorage.user['Locations_Per_Page'] = len;
                localStorage.setItem('user', JSON.stringify(this.$store.state.localStorage.user));
            });
        },
        methods:{
            searchColumn: _.debounce(function(colIndex, event){
                this.$refs.dataTable.dt.column(colIndex).search(event.target.value).draw();
            }, 300),
            btoa(str){
                try{
                    return window.btoa(str);
                }
                catch(err){
                    return str;
                }
            },
        },
    }
  </script>
  <style lang="scss">
  @import 'datatables.net-bs5';

  table.dataTable thead tr th,
  table.dataTable tbody tr td,
  table.dataTable tbody tr th {
    font-size: 0.85rem;
  }

  table.dataTable thead tr th {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .filter-label {
    display: none;
    font-size: 0.75rem;
    font-weight: bold;
    margin-bottom: 0.2rem;
    text-align: left;
  }

  @media (max-width: 992px) {
    .filter-label {
      display: block;
    }
  }
  </style>